const capitalizeFirstLetter = (word?: string): string =>
  word ? word.charAt(0).toUpperCase() + word.slice(1) : '';

export default capitalizeFirstLetter;
